import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId } from "./constants.js";
import { A as AnchorLink } from "./AnchorLink.js";
import { C as Close } from "./Close.js";
import { P as PopOverVariant, a as PopOver } from "./PopOver.js";
import styles from "./components/HelpBubble/styles.module.scss";
const HelpBubbleVariant = PopOverVariant;
const HelpBubble = React__default.forwardRef((props, ref) => {
  const {
    children,
    className = "",
    noCloseButton,
    linkText = "Mer hjelp",
    linkUrl,
    linkTarget,
    onLinkClick,
    onClose,
    closeAriaLabel,
    // Props passed on to PopOver
    showBubble,
    helpBubbleId,
    variant,
    controllerRef,
    role,
    testId
  } = props;
  const isTooltip = role === "tooltip";
  if (!showBubble && !isTooltip) {
    return null;
  }
  const helpBubbleClasses = classNames(styles.helpbubble, className);
  const contentClasses = classNames(styles.helpbubble__content, {
    [styles["helpbubble__content--close"]]: !noCloseButton && !isTooltip
  });
  const renderLink = () => {
    if (isTooltip) {
      return;
    }
    if (onLinkClick && linkText) {
      return /* @__PURE__ */ jsx("button", { className: styles.helpbubble__link, onClick: onLinkClick, type: "button", children: linkText });
    } else if (linkUrl && linkText) {
      return /* @__PURE__ */ jsx(AnchorLink, { href: linkUrl, target: linkTarget, children: linkText });
    }
  };
  const renderCloseButton = () => {
    if (noCloseButton || isTooltip) {
      return;
    }
    return /* @__PURE__ */ jsx("div", { className: styles.helpbubble__close, children: /* @__PURE__ */ jsx(Close, { small: true, onClick: onClose, ariaLabel: closeAriaLabel }) });
  };
  return /* @__PURE__ */ jsx(
    PopOver,
    {
      id: helpBubbleId,
      variant,
      controllerRef,
      role,
      ref,
      show: isTooltip && showBubble,
      testId,
      children: /* @__PURE__ */ jsxs("div", { className: helpBubbleClasses, "data-analyticsid": AnalyticsId.HelpBubble, children: [
        renderCloseButton(),
        /* @__PURE__ */ jsxs("div", { className: contentClasses, children: [
          children,
          renderLink()
        ] })
      ] })
    }
  );
});
HelpBubble.displayName = "HelpBubble";
export {
  HelpBubble as H,
  HelpBubbleVariant as a
};
//# sourceMappingURL=HelpBubble.js.map
